import { Button, Checkbox, Form, Input, Select } from "antd";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { AiOutlineMinusCircle, AiOutlinePlus } from "react-icons/ai";

const LiveEditTab = ({ form, gridData }) => {
  const liveEdit = Form.useWatch("liveEdit", form);
  const groups = Form.useWatch("groups", form) || [];

  const tileListOptions =
    (Array.isArray(gridData)
      ? gridData
          ?.filter(({ component }) => !["textBox", "comboBar"].includes(component))
          ?.map(({ chartTitle, _id }) => ({
            label: (
              <div className="ql">
                <div className="ql-editor p-0 pb-1">
                  <div className="reset-html" dangerouslySetInnerHTML={{ __html: chartTitle }}></div>
                </div>
              </div>
            ),
            // label: chartTitle,
            value: _id.toString(),
            key: _id.toString(),
          }))
      : []) || [];

  // Filter options so no duplicates across groups
  const getFilteredOptions = (groupIndex) => {
    const selectedValues = [];
    groups.forEach((_, i) => {
      if (i !== groupIndex) {
        const values = form.getFieldValue(["groups", i, "values"]) || [];
        selectedValues.push(...values);
      }
    });
    return tileListOptions?.filter((option) => !selectedValues.includes(option.value));
  };

  return (
    <>
      <Row>
        <Col xs={6}>
          <Form.Item label="" name="liveEdit" valuePropName="checked">
            <Checkbox
              onChange={() => {
                form.setFieldValue("groups", undefined);
              }}
            >
              Enable Live Edit
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>

      {liveEdit && (
        <div>
          <Form.List name="groups" initialValue={[{}]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name }) => (
                  <div key={key}>
                    <div className="d-flex gap-3 align-items-baseline ">
                      <Form.Item name={[name, "name"]} layout="horizontal" className="w-50">
                        <Input placeholder={`Group ${name + 1}`} />
                      </Form.Item>
                      :
                      <Form.Item
                        name={[name, "values"]}
                        // label={`Group ${name + 1}`}
                        layout="horizontal"
                        rules={[{ required: true, message: "Please select at least one tile!" }]}
                        className="w-100"
                      >
                        <Select placeholder={`Select Group ${name + 1}`} options={getFilteredOptions(name)} mode="multiple" maxTagCount={2} />
                      </Form.Item>
                      {fields.length > 1 && (
                        <div style={{ marginBottom: "15px", cursor: "pointer" }}>
                          <AiOutlineMinusCircle onClick={() => remove(name)} />
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                <Form.Item>
                  <Button type="dashed" hidden={fields.length >= 3} onClick={() => add()} block icon={<AiOutlinePlus />}>
                    Add New Group
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </div>
      )}
    </>
  );
};

export default LiveEditTab;

LiveEditTab.propTypes = {
  form: PropTypes.any,
  gridData: PropTypes.array,
};
